export default __webpack_public_path__ + "static/media/top-managment-course.b73ce384.jpg";